import { render, staticRenderFns } from "./ImageDropTarget.vue?vue&type=template&id=e53af50a&scoped=true&"
import script from "./ImageDropTarget.vue?vue&type=script&lang=js&"
export * from "./ImageDropTarget.vue?vue&type=script&lang=js&"
import style0 from "./ImageDropTarget.vue?vue&type=style&index=0&id=e53af50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53af50a",
  null
  
)

export default component.exports